import { ITabGroupConfig } from "../../../../App/Typings/TabPanel";
import {
  selectCurrentTab,
  updateCurrentTab,
} from "../../../../App/State/Slices/TabGroupSlice";
import { useDispatch, useSelector } from "react-redux";
import TabGroup from "../../../../App/Components/TabGroup/TabGroup";
import SortableTable from "../../../../App/Components/Table/SortableTable";
import { ITableColumn, ITablePagination } from "../../../../App/Typings/Table";
import UnassignClientTableCell from "./UnassignedClientTableCell";
import { Box, Grid } from "@mui/material";
import { useGetAssignedAttributeClientIds } from "../../../ABAC/AbacAppQueries";
import { useAppSelector } from "../../../../App/State/Store";
import { selectAbacUser } from "../../../../App/State/Slices/AbacUserSlice";
import {
  useGetAssignedClients,
  useGetUnassignedClients,
} from "../../../../App/Queries/ClientQueries";
import { IClient } from "../../../../App/Typings/Client";

export default function AdminAttributeAssignmentComponent() {
  var tabState = useSelector(selectCurrentTab);
  const { currentUserId: userId } = useAppSelector(selectAbacUser);
  var dispatch = useDispatch();

  const { data: userClientAttributeIds = [] } =
    useGetAssignedAttributeClientIds(userId);

  const { data: unassignedClients = [], isLoading: unassignedLoading } =
    useGetUnassignedClients(userClientAttributeIds);

  const { data: assignedClients = [], isLoading: assignedLoading } =
    useGetAssignedClients(userClientAttributeIds);

  const tabGroupConfig: ITabGroupConfig = {
    groupLabel: "ABAC Application Actions",
    id: "abac-app-tabs",
    currentTabState:
      tabState.currentTab !== "Assigned Clients" &&
      tabState.currentTab !== "Unassigned Clients"
        ? "Assigned Clients"
        : tabState.currentTab,
    changeTabState: (newTabState: any) => {
      dispatch(updateCurrentTab(newTabState));
    },
    tabs: [
      {
        label: "Assigned Clients",
        TabComponent: (
          <AssignedClientsTab
            assignedClients={assignedClients}
            assignedLoading={assignedLoading}
          />
        ),
      },
      {
        label: "Unassigned Clients",
        TabComponent: (
          <UnassignedClientsTab
            unassignedClients={unassignedClients}
            unassignedLoading={unassignedLoading}
          />
        ),
      },
    ],
  };
  return <TabGroup config={tabGroupConfig} />;
}

interface IAssignedClientsTabProps {
  assignedClients: IClient[];
  assignedLoading: boolean;
}

function AssignedClientsTab({
  assignedClients,
  assignedLoading,
}: IAssignedClientsTabProps) {
  const columns: ITableColumn[] = [
    { label: "Client Name", propName: "clientName" },
    { label: "", propName: "" },
  ];

  const pagination: ITablePagination = {
    enabled: true,
    rowsPerPage: [10, 20, 50],
  };

  return (
    <Grid item xs={12}>
      <Box sx={{ height: "45vh" }}>
        <SortableTable
          columns={columns}
          tableData={assignedClients}
          rowComponent={UnassignClientTableCell}
          loading={assignedLoading}
          hideSearch={false}
          defaultSortIndex={0}
          setTableData={undefined}
          reverse={false}
          customProps={undefined}
          pagination={pagination}
        />
      </Box>
    </Grid>
  );
}

interface IUnassignedClientsTabProps {
  unassignedClients: IClient[];
  unassignedLoading: boolean;
}

function UnassignedClientsTab({
  unassignedClients,
  unassignedLoading,
}: IUnassignedClientsTabProps) {
  const columns: ITableColumn[] = [
    { label: "Client Name", propName: "clientName" },
    { label: "", propName: "" },
  ];

  const pagination: ITablePagination = {
    enabled: true,
    rowsPerPage: [10, 20, 50],
  };

  return (
    <Grid item xs={12}>
      <Box sx={{ height: "45vh" }}>
        <SortableTable
          columns={columns}
          tableData={unassignedClients}
          rowComponent={UnassignClientTableCell}
          loading={unassignedLoading}
          hideSearch={false}
          defaultSortIndex={0}
          setTableData={undefined}
          reverse={false}
          customProps={undefined}
          pagination={pagination}
        />
      </Box>
    </Grid>
  );
}
